"use client";

import { c as _c } from "react/compiler-runtime";
import { SEARCH_DEBOUNCE_TIME } from "@/constants/app-defaults";
import debounce from "lodash/debounce";
import { useEffect, useMemo, useState, forwardRef, useId } from "react";
export interface SearchInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange"> {
  placeholder?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}
const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>((t0, ref) => {
  const $ = _c(27);
  let className;
  let id;
  let onChange;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      placeholder: t1,
      value: t2,
      onChange,
      className,
      id,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = id;
    $[3] = onChange;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
  } else {
    className = $[1];
    id = $[2];
    onChange = $[3];
    props = $[4];
    t1 = $[5];
    t2 = $[6];
  }
  const placeholder = t1 === undefined ? "Search..." : t1;
  const value = t2 === undefined ? "" : t2;
  const generatedId = useId();
  const inputId = id || generatedId;
  const [search, setSearch] = useState(value || "");
  let t3;
  if ($[7] !== onChange) {
    t3 = debounce(e => onChange?.(e), SEARCH_DEBOUNCE_TIME);
    $[7] = onChange;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const debouncedOnChange = t3;
  let t4;
  let t5;
  if ($[9] !== value) {
    t4 = () => {
      setSearch(value || "");
    };
    t5 = [value];
    $[9] = value;
    $[10] = t4;
    $[11] = t5;
  } else {
    t4 = $[10];
    t5 = $[11];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[12] !== debouncedOnChange) {
    t6 = () => () => {
      debouncedOnChange.cancel();
    };
    t7 = [debouncedOnChange];
    $[12] = debouncedOnChange;
    $[13] = t6;
    $[14] = t7;
  } else {
    t6 = $[13];
    t7 = $[14];
  }
  useEffect(t6, t7);
  let t8;
  if ($[15] !== debouncedOnChange) {
    t8 = e_0 => {
      setSearch(e_0.target.value);
      debouncedOnChange(e_0);
    };
    $[15] = debouncedOnChange;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const handleChange = t8;
  const t9 = props["aria-label"] || placeholder;
  const t10 = props.autoComplete || "off";
  let t11;
  if ($[17] !== className || $[18] !== handleChange || $[19] !== inputId || $[20] !== placeholder || $[21] !== props || $[22] !== ref || $[23] !== search || $[24] !== t10 || $[25] !== t9) {
    t11 = <input ref={ref} id={inputId} type="search" role="searchbox" placeholder={placeholder} value={search} onChange={handleChange} className={className} aria-label={t9} autoComplete={t10} {...props} />;
    $[17] = className;
    $[18] = handleChange;
    $[19] = inputId;
    $[20] = placeholder;
    $[21] = props;
    $[22] = ref;
    $[23] = search;
    $[24] = t10;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
});
SearchInput.displayName = "SearchInput";
export default SearchInput;